module.exports = __webpack_public_path__ + "static/media/Surgical_Oi.a0cbc7fb.jpg";